import React, { useEffect, useState } from "react";
import { Button, Modal, Row, Col } from 'react-bootstrap'
// import ReportCarousels from './ReportCarousels'
import MultiCarouselPage from './MultiCarouselPage'
import UserService from "../controllers/UserService";
import strengths from "../files/strengths.json";
import $ from 'jquery'

const SumStory = props => {

    const [title, setTitle] = useState('');
    const [activityQuestions, setActivityDetail] = useState([]);
    const [answersPercent, setAnswersPercent] = useState([]);
    const [answers1, setAnswers1] = useState([]);
    const [answers2, setAnswers2] = useState([]);
    const [attenders, setAttenders] = useState([]);
    const [maxStudent, setMaxStudent] = useState([]);
    const [teacherAnswer, setTeacherAnswer] = useState('');
    
   


    useEffect(() => {
        UserService.getActivityDetail(props.activityId).then((res) => {
            console.log(res);
            var questions = [
                res.data.data.topic.questions[0].content,
                res.data.data.topic.questions[1].content,
                res.data.data.topic.questions[2].content,
            ]
            setActivityDetail(questions);
            setTitle(res.data.data.topic.title)
            setMaxStudent(res.data.data.maxStudent);
            setTeacherAnswer(res.data.data.comment);
            if (res.data && res.data.data && res.data.data.attenders) {
                setAttenders(res.data.data.attenders.length);
            } else {
                setAttenders(0);
            }

            UserService.getAnswersPercent(props.activityId, res.data.data.topic.questions[0].id).then((res) => {

                var percent = [];
                var tempPercent = 0;
                var stringHtml;
                console.log(res.data.data.percentages);

                var myArr = Object.fromEntries(
                    Object.entries(res.data.data.percentages).sort(([, a], [, b]) => b - a)
                );

                console.log(myArr);


                Object.keys(myArr).map((aArray, i) => {
                    tempPercent = res.data.data.percentages[aArray]
                    stringHtml = `<div key="${i}" class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100" /><br>${tempPercent.toFixed(2)}%</div>`;
                    var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap" />
                    percent.push(temp);
                })

                strengths.map((strength, i) => {

                    if (res.data.data.percentages[strength.value]) {
                        // tempPercent = res.data.data.percentages[strength.value]
                    } else {
                        tempPercent = 0;


                        stringHtml = `<div key="${i}"  class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${strength.imagePath}' class="d-inline w-100" /><br>${tempPercent.toFixed(2)}%</div>`
                        // stringHtml = `<div key="${count}" className="item primary-text"><img src='/images/strengths/cards/${strength.imagePath}' className="d-inline w-100" /><br></br><span class="percent-font">${tempPercent.toFixed(2)}%</span></div>`

                        var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} class="anywhere-wrap" />
                        percent.push(temp)
                    }
                })

                // console.log(percent);
                setAnswersPercent(percent);

            })
            UserService.getAnswers(props.activityId, res.data.data.topic.questions[1].id).then((res) => {

                const items = []
                // const slide = []
                for (const [index, value] of res.data.data.entries()) {
                    var temp = `<div key="${index}" class="border-radius-12 div-ans p-3" data-value="1"><div class="item text-left">${value.answer}</div></div>`;
                    temp = <div dangerouslySetInnerHTML={{ __html: temp }} class="anywhere-wrap" />
                    items.push(temp);
                    // if (index <= 3) {
                    //     slide.push(temp);
                    // }
                }
                setAnswers1(items);
                // temp = `<div key="100" class="item p-3 bg-white text-center click-pointer" data-value="1"  id="answers1"><img style="height: 100%;" src="/images/icons/seemore.png" /></div>`
                // temp = <div dangerouslySetInnerHTML={{ __html: temp }} className="anywhere-wrap" />
                // slide.push(temp);
                // setAnswersSlide1(slide);

            })
            UserService.getAnswers(props.activityId, res.data.data.topic.questions[2].id).then((res) => {
                const items = []
                // const slide = []
                for (const [index, value] of res.data.data.entries()) {
                    var temp = `<div key="${index}" class="border-radius-12 div-ans p-3" data-value="1"><div class="item text-left">${value.answer}</div></div>`;
                    temp = <div dangerouslySetInnerHTML={{ __html: temp }} class="anywhere-wrap" />
                    items.push(temp);
                    // if (index <= 3) {
                    //     slide.push(temp);
                    // }
                }
                setAnswers2(items);
                // temp = `<div key="100" class="item p-3 bg-white text-center click-pointer" data-value="1"  id="answers2"><img style="height: 100%;" src="/images/icons/seemore.png" /></div>`
                // temp = <div dangerouslySetInnerHTML={{ __html: temp }} className="anywhere-wrap" />
                // slide.push(temp);
                // setAnswersSlide2(slide)
            })

        })

        // $(document).on("click", "#answers1", function () {
        //     setModalShowAnswer(1);
        //     setModalShow(true);
        // });

        // $(document).on("click", "#answers2", function () {
        //     setModalShowAnswer(2);
        //     setModalShow(true);
        // });

    }, [])


    const responsive3 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        }
    }



    return (
        <div>
            <Row className="blue-bg">
                <Col className="sum-story p-0 blue-bg font-sarabun">
                    {props.hideHeader !== '1' && (
                        <div>
                            <Row className="pt-2 mx-0">
                                <Col className="main-detail">
                                    <Row>
                                        <Col xs={12} className="text-center d-block d-md-none">
                                            <h2 className="primary-text font-weight-600">สรุปกิจกรรม ประจำวันที่ <span className="doNotWrap">{props.date}</span></h2>
                                        </Col>
                                        <Col md={8} className="text-left d-none d-md-inline">
                                            <h2 className="primary-text font-weight-600">สรุปกิจกรรม ประจำวันที่ <span className="doNotWrap">{props.date}</span></h2>
                                        </Col>
                                        <Col xs={12} md={4} className="d-flex">
                                            <Button className="bluesky d-inline py-1 py-md-2 px-5 bt font-sarabun-bold btn btn-primary export-btn" href={`/report/pdffile/overview/${props.activityId}/answer`} target="_blank"><h5 className="mb-0 font-weight-bold">Export</h5></Button>
                                        </Col>
                                    </Row>

                                    <Row className="pt-3 mt-0 mx-0">
                                        <Col className="px-md-0">
                                            <h3 className="py-1 bg-blue-grey border-radius-5 font-weight-600">คำตอบจากนักเรียน ({attenders}/{maxStudent}) คน</h3>
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>
                        </div>
                    )}

                    {props.summaryTitle && props.summaryTitle === '1' && (
                        <div>
                            <Row className="mx-0">
                                <Col className="main-detail px-4">
                                    <h2 className="primary-text font-weight-bold">{title}</h2>
                                </Col>
                            </Row>

                            <Row className="pt-3 mt-0 mx-0">
                                <Col className="main-detail px-4">
                                    <h3 className="py-1 bg-blue-grey border-radius-5 font-weight-600">คำตอบจากนักเรียน ({attenders}/{maxStudent}) คน</h3>
                                </Col>
                            </Row>
                        </div>
                    )}
                    {props.summaryDateTitle && props.summaryDateTitle === '1' && (
                        <div>
                            <Row className="mx-0">
                                <Col className="main-detail px-4">
                                    <h2 className="primary-text font-weight-bold">สรุปกิจกรรม ประจำวันที่ <span className="doNotWrap">{props.date}</span></h2>
                                </Col>
                            </Row>

                            <Row className="py-2 mt-0 mx-0">
                                <Col className="main-detail px-4">
                                    <h3 className="py-1 bg-blue-grey border-radius-5 font-weight-600">คำตอบจากนักเรียน ({attenders}/{maxStudent}) คน</h3>
                                </Col>
                            </Row>
                        </div>
                    )}
                    {attenders && attenders > 0 ? (
                        <div>
                            {/* <Row className="pt-3">
                                <Col className="primary-text main-detail px-4">
                                    <h4 className="pb-0 mb-0">เลือกตอบ 3 คุณค่าจากนิสัยเชิงบวก (0/3)</h4>
                                </Col>
                            </Row> */}
                            <Row className="pb-3 mx-0 px-4">
                                <Col className="text-left main-detail">
                                    <h4>{activityQuestions[0]}</h4>
                                </Col>
                            </Row>
                            <Row className="py-3 mx-0 px-4">
                                <Col className="main-detail px-0">
                                    <MultiCarouselPage data={answersPercent} responsive={responsive3} />
                                </Col>
                            </Row>

                            <Row className="pt-4 pt-md-5 mt-3 bg-white mx-0">
                                <Col className="primary-text main-detail">
                                    <h3 className="pb-0 mb-0 font-weight-600">มุมมองของนักเรียนที่มีต่อเรื่องราวนี้</h3>
                                </Col>
                            </Row>
                            <Row className="py-3 mx-0 bg-white">
                                <Col className="text-left main-detail px-4">
                                    <h4>{activityQuestions[1]}</h4>
                                </Col>
                            </Row>
                            <Row className="py-3 bg-white mx-0">
                                <Col className="main-detail px-4">
                                    <MultiCarouselPage data={answers1} responsive={responsive3} />
                                </Col>
                            </Row>

                            <Row className="mt-0 bg-light-blue mx-0" style={{ 'height': '20px' }} />

                            <Row className="pt-4 pt-md-5 bg-white mx-0">
                                <Col className="primary-text main-detail px-4">
                                    <h3 className="pb-0 mb-0 font-weight-600">แรงบันดาลใจที่ได้รับจากเรื่องราว</h3>
                                </Col>
                            </Row>

                            <Row className="py-3  bg-white mx-0">
                                <Col className="text-left main-detail px-4">
                                    <h4>{activityQuestions[2]}</h4>
                                </Col>
                            </Row>
                            <Row className="py-3 bg-white mx-0">
                                <Col className="main-detail px-4">
                                    <MultiCarouselPage data={answers2} responsive={responsive3} />
                                </Col>
                            </Row>

                        </div>
                    ) : (
                        <div>
                            <Row className="pt-3 mx-0">
                                <Col className="main-detail px-4">
                                    <h4 className="pb-0 mb-0 font-weight-600">ไม่มีผู้ร่วมกิจกรรม</h4>
                                </Col>
                            </Row>
                        </div>
                    )}
                    <Row className="pt-4 pt-md-5 mt-0 bg-light-blue mx-0">
                            <Col className="main-detail px-4">
                                <h3 className="py-1 bg-blue-grey border-radius-5 font-weight-600">ความคิด และความรู้สึกของครู</h3>
                                <h4 className="pt-1 pt-md-3 text-left">เมื่อได้อ่านมุมมองของนักเรียนที่มีต่อเรื่องราวในวันนี้ ชวนคุณครูบันทึก ความคิด และความรู้สึกที่เกิดขึ้นเพื่อสะท้อนคิดเรียนรู้ และเติบโตไปพร้อมกัน</h4>
                            </Col>
                        </Row>
                        <Row className="py-3 bg-light-blue mx-0">
                            <Col className="main-detail m-md-auto mx-3 px-2 px-md-4">
                                <Col className="border-radius-12 bg-white text-left border-blue overflow-7 p-3" >{teacherAnswer}</Col>
                            </Col>
                        </Row>
                        {(props.showBackTo && props.showBackTo === "1") && (
                            <Row className="pb-3 py-md-3 bg-white mx-0">
                                <Col className="main-detail px-4">
                                    <Button href="/activity" className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold">กลับหน้าหลัก</Button>
                                </Col>
                            </Row>
                        )}
                </Col >
            </Row>


        </div>
    )

}

export default SumStory